import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Carousel from '../Carousel/Carousel';
import UltimasNoticias from '../UltimasNoticias/UltimasNoticias';
import FacebookFeed from '../Facebookfeed/Facebookfeed';
import FacebookPostsCarousel from '../FacebookPostsCarousel/FacebookPostsCarousel';
import TwitterFeed from '../Twitterfeed/Twitterfeed';
import ServiciosCarrusel from '../Servicios/ServiciosCarrusel';
import Carouselnews from '../Carousel/Carouselnews';
import { titular } from '../../json/titular';
import { carouselInicio } from '../../json/carousel';
import './inicio.css';
import Search from '../Search/Search';

const Inicio = () => {
  const [isModalOpen, setModalOpen] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Carousel bannerData={carouselInicio} search={true} name="banner-principal" />
      <br />

      <div className='link2'>
        
          <h6 style={{ textAlign: 'center' }}>
            <b>Si te inscribiste a algún programa, ingresa al enlace, y conoce si recibirás el apoyo</b>
          </h6>
  
      </div>   
      
        <Carouselnews />
         
     <h4 className='title'>¿Con qué trámite o servicio te podemos ayudar?</h4> 
      <div
        className="search"
        style={{
          marginTop: '10px',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '80%',
          maxWidth: '300px',
          margin: '20px auto',
          backgroundColor: '#f9f9f9',
          borderRadius: '8px',
          boxShadow: '0 3px 6px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Search style={{ width: '100%', maxWidth: '500px' }} name="search" />
      </div>
      <div className='link2'>
        <a href='/Servicios' className='link-hover'>
          <h6 style={{ textAlign: 'center' }}>
            <b>Servicios de la Secretaría</b>
          </h6>
        </a>
      </div>   

    

      <div className='container'>
        <div className='row'>
          <div className='col-12'>
            <div className='secretaria_logo'>
              <div className='secretaria_logo_img' style={{ backgroundImage: `url("https://cdn.hidalgo.gob.mx/gobierno/images/iconosSec/Bienestar.svg")` }}>
              </div>
            </div>
          </div>
          
          <div className='secretaria_name'>
            <h1>SECRETARÍA DE BIENESTAR E INCLUSIÓN SOCIAL</h1>
          </div>
          
          <div className='secretaria_funciones'>
            <h3 className='title'>FUNCIONES</h3>
            <hr className='hr-gob'/>
            <p>La empatía es la base de nuestra labor como servidores populares. No estamos aquí para tomar decisiones desde la distancia, sino para vivir de cerca las realidades del pueblo, sentir sus necesidades y trabajar para cambiarlas. Este compromiso con la cercanía y el respeto es lo que nos diferencia de administraciones pasadas, que a menudo perdían de vista a las personas a las que servían. Siempre del lado de nuestra gente; escuchamos, aprendemos y trabajamos para continuar el camino de la transformación.</p>
            
            <div className='texto-en-tres-columnas'>
              <div className='columna'>
                <h1 style={{ textAlign:'center' }}>Misión</h1>
                <p>La Secretaría de Bienestar e Inclusión Social, es la dependencia de Gobierno del Estado de Hidalgo, encargada de generar condiciones para el desarrollo de individualidad de la población, estableciendo un modelo de bienestar e inclusión social integrada, orientado a la generación de capacidades humanas que en forma simultanea promueva y atienda a las personas en condiciones de vulnerabilidad social y en situación de pobreza, superando las prácticas tradiciones de asistencialismo.</p>
              </div>
              <div className='columna'>
                <h1 style={{ textAlign:'center' }}>Visión</h1>
                <p>Consolidar políticas sociales mediante la coordinación efectiva de los diversos órdenes de gobierno y la sociedad civil, que fomenten las condiciones de un bienestar generalizado, sustentable y equitativo, basado en el desarrollo humano integral.</p>
              </div>
              <div className='columna'>
                <h1 style={{ textAlign:'center' }}>Objetivo</h1>
                <p>Promover acciones y estrategias para el ejercicio de los derechos ciudadanos en materia social con énfasis en la reducción de causas de vulnerabilidad en el Estado, generando igualdad de oportunidades de desarrollo para todos los hidalguenses.</p>
              </div>
              <div className='btn_organigrama'>
               <Link to="/Transparencia/Rubros/DetalleRubro/02%20-%20Estructura" target='_blank' rel='noopener noreferrer'>Organigrama</Link>
               <Link to="/Transparencia/Rubros/DetalleRubro/01%20-%20Normatividad" target='_blank' rel='noopener noreferrer'>Normatividad</Link>
              </div>
            </div>
          </div>
        </div>
        
        <div className='row'>
          <div className='col-12'>
            <div className='notes_title'>
              <h3 className='title'>TITULAR DE LA SECRETARÍA</h3>
              <hr className='hr-gob'/>
            </div>
            <div className='section_notes'>
              {
                titular.map((item, index) =>(
                  <React.Fragment key={index}>
                    <div className='sec_photo'>
                      <div className='img_secretario' style={{ backgroundImage: `url("${ item.imagen }")` }}>
                      </div>
                    </div>
                    <div className='sec_container'>
                      <div className='sec_name'>
                        <h3>{ item.nombre }</h3>
                      </div>
                      <div className='sec_function'>
                        <h4>Funciones del Secretario</h4>
                        <p>{ item.funcion }</p>
                        <div className='btn_agenda'>
                          <Link to="Agenda">Agenda</Link>
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                ))
              }
            </div>
          </div>
        </div>

         <UltimasNoticias/>

        {/* REDES SOCIALES - FACEBOOK Y X */}
<div className='row'>
  <div className='col-12'>
    {/* Título general */}
    <div className='notes_title'>
      <h3 className='title'>REDES SOCIALES</h3>
      <hr className='hr-gob'/>
    </div>
    
    {/* Facebook */}
    <h4 style={{ 
      textAlign: 'center', 
      margin: '30px 0 20px 0', 
      color: '#333', 
      fontWeight: '600',
      fontFamily: "'Montserrat', sans-serif"
    }}>
      Facebook
    </h4>
    <div className='section_notes' style={{ textAlign: 'center', paddingBottom: '40px' }}>
      <div style={{ 
        border: '0px solid #6b0f1a', 
        borderRadius: '8px', 
        padding: '4px',
        display: 'inline-block',
        maxWidth: '100%'
      }}>
        <FacebookFeed height={600} />
      </div>
    </div>
    
    {/* X / Twitter */}
    <h4 style={{ 
      textAlign: 'center', 
      margin: '20px 0 20px 0', 
      color: '#333', 
      fontWeight: '600',
      fontFamily: "'Montserrat', sans-serif"
    }}>
      X
    </h4>
    <div style={{ width: '50%', minWidth: '300px', margin: '0 auto', paddingBottom: '40px' }}>
      <TwitterFeed />
    </div>
  </div>
</div>


        <div className='row'>
          <div className='col-12'>
            <div className='section_map'>
              <div className='map_name'>
                <h3 className='title'>UBICACIÓN</h3>
                <hr className='hr-gob'/>
              </div>
              <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d340.8423059074025!2d-98.74394389104276!3d20.116873659015482!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1090061491569%3A0xdf260c058c708e9f!2sSecretar%C3%ADa%20de%20Agricultura%20y%20Desarrollo%20Rural%20del%20Gobierno%20del%20Estado%20de%20Hidalgo!5e0!3m2!1ses-419!2smx!4v1789166562113!5m2!1ses-419!2smx" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"
                      width="100%" 
                      height="300" 
                      frameborder="0" 
                      style={{border:0, marginBottom:50}} 
                      allowfullscreen>
              </iframe>
            </div>
          </div>
        </div>

        <div>
          <p></p>
        </div> 
      </div>
    </>
  )
}

export default Inicio;
